export const REPORT_PLATFORM_DEFAULT_YEAR = 2025

export const REPORT_PLATFORM_ITEMS = [
  {
    key: 'insured-plot-area',
    title: '2025年度翁牛特旗种植险投保地块情况统计'
  },
  {
    key: 'policy-crop-stat',
    title: '2025年度翁牛特旗种植险个体投保情况统计'
  },
  {
    key: 'remote-loss-stat',
    title: '2025年度翁牛特旗种植险遥感监测损失面积统计'
  },
  {
    key: 'agri-feature-stat',
    title: '翁牛特旗农业特色调查情况统计'
  },
  {
    key: 'underwriting-stat',
    title: '2025年度翁牛特旗种植险承保数据统计表'
  }
]
